<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/AduanMasyarakat">Aduan Masyarakat</a></li>
                                <li class="breadcrumb-item active">Pengaturan Aduan Masyarakat</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Form Input Aduan Masyarakat</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12 float-left pb-2">
                                            <label v-if="(bahasa === null) || (bahasa == 'ina')">Saluran Aduan <small
                                                    class="text-info">
                                                    (*wajib
                                                    dipilih)</small></label>
                                            <label v-else>Complaint Channel <small class="text-info">
                                                    (*must be selected)</small></label>
                                            <v-select :options="saluranaduan" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedsaluranaduan"
                                                @update:modelValue="onsaluranaduanChange"
                                                style="background-color: #ffffff;"></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left pb-2">
                                            <label v-if="(bahasa === null) || (bahasa == 'ina')">Kategori Aduan <small
                                                    class="text-info">
                                                    (*wajib
                                                    dipilih)</small></label>
                                            <label v-else>Complaint Type <small class="text-info">
                                                    (*must be selected)</small></label>
                                            <v-select :options="masteraduan" :reduce="(label) => label.code"
                                                label="label" v-model="defaultSelectedmasteraduan"
                                                @update:modelValue="onmasteraduanChange"
                                                style="background-color: #ffffff;"></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left pb-2">
                                            <label v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi <small
                                                    class="text-info">
                                                    (*wajib dipilih)</small></label>
                                            <label v-else>Location <small class="text-info">
                                                    (*must be selected)</small></label>
                                            <v-select :options="lokasi" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedlokasi" @update:modelValue="onlokasiChange"
                                                style="background-color: #ffffff;color: black;"></v-select>
                                        </div>
                                        <div class="col-sm-12 float-left">
                                            <label>PIU / Penanggungjawab<small class="text-info"> (*wajib
                                                    dipilih)</small></label>
                                            <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                                v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                                style="background-color: #ffffff;"></v-select>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Nama Pengadu <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="nama"
                                                    name="nama" placeholder="Nama Pengadu" v-model="nama">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Alamat Email</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="alamat"
                                                    name="alamat" placeholder="Alamat Email" v-model="alamat">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Nomor Telp</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="nohp"
                                                    name="nohp" placeholder="Nomor Telp" v-model="nohp">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Judul Aduan <small class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm" id="judul"
                                                    name="judul" placeholder="Judul Aduan" v-model="judul">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label v-if="(bahasa === null) || (bahasa == 'ina')">Aduan <small
                                                    class="text-info"> (*wajib
                                                    diisi)</small></label>
                                            <label v-else>Complaint<small class="text-info"> (*required)</small></label>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <quill-editor v-model:value="aduan"
                                                        style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 float-left">&nbsp;</div>
                                        <div class="col-sm-12 float-left">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" v-if="(secretencData == 'Tambah')" data-toggle="tooltip"
                                        data-placement="left" title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        v-if="(secretencData != 'Tambah')" @click="update()" data-toggle="tooltip"
                                        data-placement="left" title="Update data.."><i class="fa fa-check-circle"></i>
                                        Update</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i> Batal</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">&nbsp;</div>
                <div class="col-sm-12">&nbsp;</div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            bahasa: localStorage.getItem("bahasasistem"),
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            nama: '',
            alamat: '',
            nohp: '',
            judul: '',
            aduan: '',
            datamasteraduan: [],
            masteraduan: [],
            defaultSelectedmasteraduan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: 0,
            },
            selectedmasteraduan: '',
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedlokasi: '',
            datasaluranaduan: [],
            saluranaduan: [],
            defaultSelectedsaluranaduan: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: 0,
            },
            selectedsaluranaduan: '',

            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Pilih Salah Satu',
                tag: '',
            },
            selectedid_user: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            validasi: false,
        }
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/AduanMasyarakat");
        },
        async ambilmaster() {
            this.halamanloading = true;

            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI5.get("parastapainnovation_userproject-GetALLPIU?random=" + random + "&project_id=" + this.project_id+ "&id_user=" + this.levelinstansi+"&role=" +this.roleuser).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataid_user = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.kodesatker,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
            const mainAPI9 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI9.get("parastapainnovationMasyarakat-Master?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamasteraduan = [];
                        this.masteraduan = [];
                        this.datamasteraduan = Response.data.content.data;
                        this.datamasteraduan.forEach((item) => {
                            this.masteraduan.push({
                                label: item.kategoriMasalahNm,
                                code: this.datamasteraduan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.masteraduan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: 0,
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationMasyarakat-Media?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datasaluranaduan = [];
                        this.saluranaduan = [];
                        this.datasaluranaduan = Response.data.content.data;
                        this.datasaluranaduan.forEach((item) => {
                            this.saluranaduan.push({
                                label: item.nama,
                                code: this.datasaluranaduan.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.saluranaduan.unshift({
                            label: 'Pilih Salah Satu',
                            code: 0,
                            tag: 0,
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI9.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        onmasteraduanChange(a) {
            try {
                this.selectedmasteraduan = this.masteraduan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onsaluranaduanChange(a) {
            try {
                this.selectedsaluranaduan = this.saluranaduan[a].tag;
            }
            catch (err) {
                return;
            }
        },
        onlokasiChange(a) {
            try {
                this.selectedlokasi = this.lokasi[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedlokasi);
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            var mainAPIDataSingel = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPIDataSingel.get("parastapainnovationaduan-GetIDData?id=" + this.secretencData + "&random=" + random + "&project_id=" + this.project_id+ "&id_user=" + this.levelinstansi + "&role=" + this.roleuser).then(
                Response => {
                    this.nama = Response.data.content.data[0].nama;
                    this.alamat = Response.data.content.data[0].alamat;
                    this.nohp = Response.data.content.data[0].nohp;
                    this.judul = Response.data.content.data[0].judul;
                    this.aduan = Response.data.content.data[0].aduan;

                    this.defaultSelectedmasteraduan = {
                        code: Response.data.content.data[0].jenis,
                        label: Response.data.content.data[0].kategoriMasalahNm,
                        tag: Response.data.content.data[0].jenis,
                    };
                    this.selectedmasteraduan = Response.data.content.data[0].jenis;

                    this.defaultSelectedlokasi = {
                        code: Response.data.content.data[0].lokasi,
                        label: Response.data.content.data[0].namalokasi,
                        tag: Response.data.content.data[0].lokasi,
                    };
                    this.selectedlokasi = Response.data.content.data[0].lokasi;

                    this.defaultSelectedsaluranaduan = {
                        code: Response.data.content.data[0].asaladuan,
                        label: Response.data.content.data[0].namaasaladuan,
                        tag: Response.data.content.data[0].asaladuan,
                    };
                    this.selectedsaluranaduan = Response.data.content.data[0].asaladuan;

                    this.defaultSelectedid_user = {
                        code: Response.data.content.data[0].penanggungjawab,
                        label: Response.data.content.data[0].full_name,
                        tag: Response.data.content.data[0].penanggungjawab,
                    };
                    this.selectedid_user = Response.data.content.data[0].penanggungjawab;
                    this.halamanloading = false;
                }
            ).catch(error => {
                //console.log(error);
                swal.fire('Peringatan', error, 'error');
                this.halamanloading = false;
                return false;
            })
        },
        validasidata() {
            if ((this.selectedsaluranaduan == '') || (this.selectedsaluranaduan === null) || (this.selectedsaluranaduan === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Saluran..',
                });
                return false;
            }
            if ((this.selectedmasteraduan == '') || (this.selectedmasteraduan === null) || (this.selectedmasteraduan === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Kategori..',
                });
                return false;
            }
            if ((this.selectedlokasi == '') || (this.selectedlokasi === null) || (this.selectedlokasi === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Lokasi..',
                });
                return false;
            }
            if (document.getElementById('nama').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('nama').focus();
                return false;
            }
            if (document.getElementById('judul').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('judul').focus();
                return false;
            }
            if (this.aduan == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Aduan',
                });
                return false;
            }
            if ((this.selectedid_user == '') || (this.selectedid_user === null) || (this.selectedid_user === undefined)) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Pilih Lokasi..',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var tahunregister = this.pad2(new Date().getFullYear());
            var bulanregister = this.pad2(new Date().getMonth() + 1);
            var tanggalregister = this.pad2(new Date().getDate());
            var jamregister = this.pad2(new Date().getHours());
            var menitregister = this.pad2(new Date().getMinutes());
            var detikregister = this.pad2(new Date().getSeconds());

            var koderegistrasi = this.makeid(5) + tahunregister + bulanregister + tanggalregister + jamregister + menitregister + detikregister;
            var fd = new FormData();
            fd.append("asaladuan", this.selectedsaluranaduan);
            fd.append("jenis", this.selectedmasteraduan);
            fd.append("register", koderegistrasi);
            fd.append("lokasi", this.selectedlokasi);
            fd.append("nama", this.nama);
            fd.append("alamat", this.alamat);
            fd.append("nohp", this.nohp);
            fd.append("judul", this.judul);
            fd.append("aduan", this.aduan);
            fd.append("penanggungjawab", this.selectedid_user);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationaduan-TambahAduanMasyarakat", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/AduanMasyarakat");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var tahunregister = this.pad2(new Date().getFullYear());
            var bulanregister = this.pad2(new Date().getMonth() + 1);
            var tanggalregister = this.pad2(new Date().getDate());
            var jamregister = this.pad2(new Date().getHours());
            var menitregister = this.pad2(new Date().getMinutes());
            var detikregister = this.pad2(new Date().getSeconds());

            var koderegistrasi = this.makeid(5) + tahunregister + bulanregister + tanggalregister + jamregister + menitregister + detikregister;
            var fd = new FormData();
            fd.append("asaladuan", this.selectedsaluranaduan);
            fd.append("jenis", this.selectedmasteraduan);
            fd.append("register", koderegistrasi);
            fd.append("lokasi", this.selectedlokasi);
            fd.append("nama", this.nama);
            fd.append("alamat", this.alamat);
            fd.append("nohp", this.nohp);
            fd.append("judul", this.judul);
            fd.append("aduan", this.aduan);
            fd.append("penanggungjawab", this.selectedid_user);
            fd.append("project_id", this.project_id);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.secretencData);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationaduan-UpdateAduanMasyarakat", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/AduanMasyarakat");
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambilmaster();
        if (this.secretencData != 'Tambah') {
            this.AmbilDataSingel();
        }
    }
}
</script>
<style></style>